export default "/images/6ec512163c25b9314847a8cf3feccdad.png";